// @mui
import {
    Stack,
    Drawer,
    Divider,
    IconButton,
    Typography,
    Alert,
    Box,
    Tabs,
    Tab,
    MenuItem,
    TableContainer,
    Table,
    TableCell,
    TableRow,
    TableHead,
    TableBody,
    Button,
} from '@mui/material';
import Iconify from '../iconify/Iconify';
import Scrollbar from '../scrollbar/Scrollbar';
import { useTranslation } from 'react-i18next';
import { FormatNumber, glb_sv, sendRequest, serviceList, session } from 'src/utils';
import dayjs from 'dayjs';
import React, { useRef, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { TabContext, TabPanel } from '@mui/lab';
import Loader from '../loader/loader';
import { toast } from 'react-toastify';
import moment from 'moment';
import ImageQRCodeModal from '../modal/ImageQRCodeModal';
import ViewImageModal from '../modal/ViewImageModal';

export default function DeviceDetail({ isBorrow = false, open, isGivedevice, setOpen, device = {} }) {
    const theme = useTheme();
    const [getFlags, setGetFlags] = useState(false);
    const [tableData, setTableData] = useState([]);
    const { t } = useTranslation();
    const getRef = useRef(false);
    const [value, setValue] = React.useState('device');
    const [visibleImageQR, setVisibleImageQR] = useState(false);

    const [visibleImage, setVisibleImage] = useState(false);
    const lang = localStorage.getItem(session.LANGUAGE);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const renderDepartment = (arrDepart) => {
        let str = '';
        if (arrDepart) {
            arrDepart.map((department) => {
                if (department.value !== 1) {
                    str += department.label + ', ';
                }
            });
        }
        return str;
    };

    const getData = () => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        const InVal = [
            moment().subtract(1, 'months').format('YYYYMMDD'),
            moment().format('YYYYMMDD'),
            device?.device_id ? device.device_id : 0,
        ];
        sendRequest(serviceList.getPepleTransaction, InVal, getDataResult, true, timeOutFunct, 40000);
    };

    const getDataResult = (reqInfoMap, message) => {
        getRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setTableData(message.proc_data.rows[0].o_1);
        }
    };

    const timeOutFunct = (reqInfo) => {
        getRef.current = false;
        setGetFlags(false);
    };

    return (
        <>
            <Drawer
                anchor="right"
                open={open}
                onClose={() => setOpen(false)}
                PaperProps={{
                    sx: { width: { sm: '100%', md: 500 }, border: 'none', overflow: 'hidden' },
                }}
            >
                <Loader loading={getFlags} />
                <ImageQRCodeModal
                    visible={visibleImageQR}
                    setVisible={setVisibleImageQR}
                    valueImageQR={device?.device_cd}
                    valueNameDevice={device?.device_nm}
                    valueCodeDevice={device?.device_cd}
                />
                <ViewImageModal
                    setVisible={setVisibleImage}
                    visible={visibleImage}
                    url={
                        device?.img_device
                            ? `${glb_sv.urlGetProductImage(device?.img_device)}`
                            : `${glb_sv.urlGetProductImage(device?.pic_device)}`
                    }
                    image_name={glb_sv.convertMultipleLanguages(device?.device_cd)}
                />
                <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: 1, py: 2 }}>
                    <Typography variant="subtitle1" sx={{ ml: 1 }}>
                        {t('info') + ' ' + t('device').toLocaleLowerCase()}
                    </Typography>
                    <IconButton
                        onClick={() => {
                            setOpen(false);
                        }}
                    >
                        <Iconify icon="eva:close-fill" />
                    </IconButton>
                </Stack>

                <Divider />
                {/* tap parent */}
                <Scrollbar>
                    <Box sx={{ width: '100%', typography: 'body1', position: 'relative' }}>
                        <TabContext value={value}>
                            <Box
                                sx={{
                                    borderColor: 'divider',
                                    position: 'fixed',
                                    width: '100%',
                                    backgroundColor: '#fff',
                                }}
                            >
                                <Tabs
                                    value={value}
                                    onChange={handleChange}
                                    sx={{ backgroundColor: '#fff', width: '100%' }}
                                    textColor="primary"
                                    // variant="fullWidth"
                                    aria-label="basic tabs example"
                                >
                                    <Tab label={t('device')} value={'device'} sx={{ backgroundColor: '#fff' }} />
                                    <Tab label={t('property')} value={'property'} sx={{ backgroundColor: '#fff' }} />
                                    {isBorrow && (
                                        <Tab
                                            label={t('giver')}
                                            value={'giver'}
                                            onClick={getData}
                                            sx={{ backgroundColor: '#fff' }}
                                        />
                                    )}
                                </Tabs>
                            </Box>
                            {/* tap con */}
                            <Stack paddingTop={3}>
                                {' '}
                                <TabPanel value={'device'} dir={theme.direction}>
                                    <Stack spacing={1} sx={{ p: 0 }}>
                                        {!isGivedevice && device?.qty > device.inventory ? (
                                            <Alert
                                                sx={{ alignItems: 'flex-start' }}
                                                severity="warning"
                                                style={{ marginBottom: '20px' }}
                                            >
                                                <div>
                                                    <Typography
                                                        fontWeight="lg"
                                                        sx={{ fontWeight: '600', fontSize: '17px' }}
                                                        mt={0.25}
                                                    >
                                                        {t('warning')}
                                                    </Typography>
                                                    <Typography fontSize="sm" sx={{ opacity: 0.8 }}>
                                                        {t('')}
                                                        <b>
                                                            {device?.qty}/{device?.inventory}
                                                        </b>
                                                    </Typography>
                                                </div>
                                            </Alert>
                                        ) : (
                                            ''
                                        )}
                                        <Stack direction="column" sx={{ px: 1, py: 1 }}>
                                            <Stack display={'flex'} alignItems="center" justifyContent={'center'}>
                                                <img
                                                    onClick={() => setVisibleImage(true)}
                                                    style={{
                                                        maxWidth: '100%',
                                                        width: '60%',
                                                        backgroundColor: '#999',
                                                        cursor: 'pointer',
                                                    }}
                                                    src={
                                                        device?.img_device
                                                            ? `${glb_sv.urlGetProductImage(device?.img_device)}`
                                                            : `${glb_sv.urlGetProductImage(device?.pic_device)}`
                                                    }
                                                    alt=""
                                                />
                                                {device?.device_cd && (
                                                    <Button
                                                        onClick={() => setVisibleImageQR(true)}
                                                        startIcon={<Iconify icon="clarity:qr-code-line" />}
                                                    >
                                                        QR
                                                    </Button>
                                                )}
                                            </Stack>
                                            <Stack spacing={0.5} sx={{ pl: 1.5, pt: 3 }}>
                                                <Typography
                                                    variant="subtitle1"
                                                    sx={{ color: 'text.primary', fontSize: '18px' }}
                                                >
                                                    {device?.device_nm &&
                                                        glb_sv.convertMultipleLanguages(device?.device_nm)}
                                                </Typography>
                                                <Stack
                                                    display={'flex'}
                                                    flexDirection={'row'}
                                                    flexWrap={'wrap'}
                                                    gap={2}
                                                    justifyContent={'space-between'}
                                                >
                                                    <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
                                                        {t('code_device')}: {device?.device_cd}
                                                    </Typography>
                                                    <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
                                                        {t('price')}: {FormatNumber(device?.price)}
                                                    </Typography>
                                                </Stack>
                                                <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
                                                    {t('supplier')}: {device?.supplier_nm}
                                                </Typography>
                                                <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
                                                    {t('producer')}: {device?.producer?.label}
                                                </Typography>
                                                <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
                                                    {t('department')}: {renderDepartment(device?.depart_json)}
                                                </Typography>
                                                <Stack
                                                    display={'flex'}
                                                    flexDirection={'row'}
                                                    flexWrap={'wrap'}
                                                    gap={2}
                                                    justifyContent={'space-between'}
                                                >
                                                    <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
                                                        {t('day_expected')}:
                                                        {device?.status_action === '0'
                                                            ? dayjs(device?.expiry_date, 'YYYYMMDD').format(
                                                                  'DD/MM/YYYY'
                                                              )
                                                            : '--/--'}
                                                    </Typography>
                                                    <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
                                                        {t('status')}:
                                                        {device?.status_action === '0' ? t('borrowing') : t('take')}
                                                    </Typography>
                                                </Stack>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                </TabPanel>
                                <TabPanel value={'property'} dir={theme.direction} style={{padding: '24px'}}>
                                 <Box style={{padding: '24px 0px 0px 12px'}}>
                                       {device?.properties_device?.length > 0 &&
                                        device?.properties_device.map((property, index) => (
                                            <Box key={index} sx={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                                                <Typography
                                                    variant="body2"
                                                    sx={{ color: 'text.secondary', paddingRight: 0.3 }}
                                                    noWrap
                                                ></Typography>
                                                {property.label
                                                    ? glb_sv.convertMultipleLanguages(property.label) +
                                                      ': ' +
                                                      glb_sv.convertMultipleLanguages(property?.value)
                                                    : '--/--'}
                                            </Box>
                                        ))}
                                    {device?.pic_properties_device && (
                                        <Box key={device?.pic_properties_device} sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    color: 'text.primary',
                                                    width: 'fit-content',
                                                }}
                                            >
                                                <Typography noWrap>{t('img_properties')}</Typography>
                                                <img
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => setVisibleImage(true)}
                                                    src={
                                                        device?.pic_properties_device &&
                                                        `${glb_sv.urlGetProductImage(device?.pic_properties_device)}`
                                                    }
                                                    alt=""
                                                />
                                            </Typography>
                                        </Box>
                                    )}
                                 </Box>
                                </TabPanel>
                                <Stack className="srcoll-test" sx={{ maxHeight: '100%', overflowY: 'scroll' }}>
                                    <TabPanel value={'giver'} dir={theme.direction}>
                                        <TableContainer>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>{t('STT')}</TableCell>
                                                        <TableCell align="left">{t('name_giver')}</TableCell>
                                                        <TableCell align="left">{t('quantity_category')}</TableCell>
                                                        <TableCell align="left">{t('day_borrow')}</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {tableData.length > 0 &&
                                                        tableData.map((item, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell>{index + 1}</TableCell>
                                                                <TableCell align="left">{item?.user_nm}</TableCell>
                                                                <TableCell align="left">{item?.qty}</TableCell>
                                                                <TableCell align="left">
                                                                    {glb_sv.formatDate(
                                                                        item?.transaction_dt,
                                                                        'YYYYMMDDHHmmss'
                                                                    )}
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </TabPanel>
                                </Stack>
                            </Stack>
                        </TabContext>
                    </Box>
                </Scrollbar>
            </Drawer>
        </>
    );
}
